// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4404":"css/admin-app.6872","7193":"css/app.6872"}[chunkId] + ".css";
};